import { getRequest } from '@/core';
import { savedLoadPlanningSearches } from '@/requests';

export default async function getSavedLoadPlanningSearchCountRequest(id) {
	let url = savedLoadPlanningSearches.getCountByIdPath(id);
	let response = await getRequest(url);
	return response;
}
